import React from "react";

const RecentSearches = ({ items = [], onSelect }) => {
  if (!items.length) return null;
  return (
    <div className="panel">
      <div className="card-title">Recent Searches</div>
      <div className="chip-row" style={{ marginTop: 8 }}>
        {items.map((item, idx) => (
          <button key={`${item}-${idx}`} className="nav-link" onClick={() => onSelect(item)}>
            {item}
          </button>
        ))}
      </div>
    </div>
  );
};

export default RecentSearches;
